import {
  Swiper,
  Navigation,
  Pagination,
  Controller,
  EffectFade,
  Autoplay,
  Scrollbar
  // Parallax,
} from 'swiper/dist/js/swiper.esm';

Swiper.use([
  Navigation,
  Pagination,
  Controller,
  EffectFade,
  Autoplay,
  Scrollbar,
  // Parallax,
]);

export default Swiper;
